export default (sectionId) =>
  new Promise((resolve, reject) => {
    window.axios
      .delete(`${process.env.VUE_APP_API_ADMIN_LOCATION}homefeed/section/${sectionId}`)
      .then(() => resolve())
      .catch((error) => {
        reject(error);
      });
  });
